import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import {
  setFilterChecklistValues,
  setFilterTagList
} from 'src/redux/dashboard';
import { scanPageRestriction } from '../../config/TextMessage';
import { getFilteredUrlMatches } from '../utils/massFilterUtils';
import { MassFilterModalProps, FilterTagList } from '../types';

export const useMassFilter = ({
  handCloseModal,
  filteredURL,
  setChecklistValues,
  difference,
  setMassFilterSnackBarOpen
}: MassFilterModalProps) => {
  const dispatch = useDispatch();

  const rawFilterTagList = useSelector(
    (state: RootState) => state.dashboard.filterTagList
  );

  const filterTagList: FilterTagList = Array.isArray(rawFilterTagList)
    ? { tags: [], urls: [] }
    : (rawFilterTagList as FilterTagList) || { tags: [], urls: [] };

  const [tags, setTags] = useState<string[]>(filterTagList.tags || []);
  const [massFilterData, setMassFilterData] = useState<string[]>(
    filterTagList.urls || []
  );
  const [checklistValues, setCheckValues] = useState<string[]>(
    filterTagList.urls || []
  );
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState<boolean | null>(null);

  const activePlanName = useSelector(
    (state: RootState) => state.user.activePlan
  );

  const filterUrlLength = filterTagList?.urls?.length || 0;
  const skipUrlNumber = difference - scanPageRestriction[activePlanName]?.pages;

  // Logic from original file:
  // let skipNumberDifference = skipUrlNumber - checklistValues?.length;
  // skipNumberDifference = skipNumberDifference + filterUrlLength;
  const skipNumberDifference =
    skipUrlNumber - checklistValues?.length + filterUrlLength;

  const handleTagsChange = (event: any, newTags: string[]) => {
    const lowerCaseTags = newTags.map((tag) => tag.toLowerCase());
    setTags(newTags);
    filterUrls(lowerCaseTags);
  };

  const handleTagDelete = (tagToDelete: string) => {
    const updatedTags = tags.filter((tag) => tag !== tagToDelete);
    setTags(updatedTags);
    filterUrls(updatedTags.map((t) => t.toLowerCase()));
  };

  const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (event.target.checked) {
      setCheckValues([...checklistValues, value]);
    } else {
      setCheckValues(checklistValues.filter((item) => item !== value));
    }
  };

  const filterUrls = (tagsToFilter: string[]) => {
    const matches = getFilteredUrlMatches(filteredURL, tagsToFilter);
    setMassFilterData(matches);
    setCheckValues(matches);
  };

  const handleApply = () => {
    setChecklistValues(checklistValues);
    dispatch(setFilterChecklistValues(checklistValues));
    dispatch(setFilterTagList({ tags, urls: checklistValues }));
    setMassFilterSnackBarOpen({
      open: true,
      number: checklistValues?.length
    });
    handCloseModal();
  };

  return {
    tags,
    setTags,
    massFilterData,
    checklistValues,
    inputValue,
    setInputValue,
    isLoading,
    activePlanName,
    skipNumberDifference,
    handleTagsChange,
    handleTagDelete,
    handleCheckBoxChange,
    handleApply,
    filterUrls
  };
};
